import { Box } from '@vouched.id/vault';
import React from 'react';
import { LicenseField, PropertyGroup } from './LicenseField';
import { toTitleCase } from 'utils/format';
export function extractDigitalIDData(request, result) {
    const { parameters } = request;
    return {
        idType: result?.type,
        issuingCountry: result?.country ?? '',
        issuingAuthority: result?.country ?? '',
        familyName: result?.lastName ?? '',
        givenName: result?.firstName ?? '',
        birthDate: result?.dob ?? '',
        issueDate: result?.issueDate ?? '',
        expireDate: result?.expireDate ?? '',
        documentNumber: result?.documentNumber ?? result?.id ?? '',
        gender: result?.gender?.gender ?? '',
        eyeColor: result?.eyeColor ?? '',
        height: result?.height ?? '',
        weight: result?.weight ?? '',
        address: result?.address ?? '',
        digitalPortraitPhotoUrl: parameters.digitalPortraitPhotoUrl
    };
}
// Map Trinsic DocumentType enum values to friendly display names
const DOCUMENT_TYPE_DISPLAY_NAMES = {
    DriversLicense: "Driver's License",
    'drivers-license': "Driver's License",
    Passport: 'Passport',
    passport: 'Passport',
    NationalId: 'National ID',
    'national-id': 'National ID',
    IdCard: 'ID Card',
    'id-card': 'ID Card',
    Other: 'ID',
    other: 'ID'
};
const getDocumentTypeDisplayName = (documentType) => {
    if (!documentType)
        return 'ID';
    const displayName = DOCUMENT_TYPE_DISPLAY_NAMES[documentType];
    if (displayName)
        return displayName;
    return toTitleCase(documentType);
};
export const DigitalID = ({ data }) => {
    return (React.createElement(Box, { className: "mock-digital-id", "data-ph-mask": true, style: {
            minHeight: '300px',
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '1.75rem',
            boxShadow: 'rgba(0, 0, 0, 0.12) 0px 0.5px 4px, rgba(0, 0, 0, 0.12) 0px 6px 13px'
        }, width: ['100%', '100%', '500px'] },
        React.createElement(Box, { style: {
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'baseline'
            } },
            React.createElement(Box, { style: {
                    fontSize: '2.5rem',
                    fontWeight: '600',
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'flex-start'
                } },
                "Mobile ",
                getDocumentTypeDisplayName(data.idType))),
        React.createElement(Box, { style: {
                display: 'flex',
                height: '-webkit-fill-available',
                justifyContent: 'space-between',
                marginTop: '0.5rem',
                paddingTop: '0.5rem',
                gap: '1.5rem'
            } },
            React.createElement(Box, null,
                React.createElement(Box, { style: { position: 'relative' } },
                    React.createElement("img", { src: data.digitalPortraitPhotoUrl, style: {
                            width: '148px',
                            height: '205px',
                            backgroundColor: '#555e74',
                            borderRadius: '8px',
                            boxShadow: '0 0 0 4px #f3f5f6 inset',
                            border: '2px solid rgb(227, 230, 238)',
                            position: 'relative',
                            flexShrink: 0
                        } }),
                    React.createElement(Box, { style: {
                            position: 'absolute',
                            inset: 0,
                            borderRadius: '10px',
                            boxShadow: 'inset 0 0 0 4px #f3f5f6',
                            pointerEvents: 'none'
                        } })),
                React.createElement(Box, { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '1rem auto auto',
                        fontSize: '1.1rem'
                    } }, "Digital Identification")),
            React.createElement(Box, { style: {
                    borderTop: '1px solid rgb(0, 0, 0, 0.1)',
                    paddingTop: '1.5rem',
                    width: '100%'
                } },
                React.createElement(Box, { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: '100%'
                    } },
                    React.createElement(Box, { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem'
                        } },
                        React.createElement(PropertyGroup, null,
                            React.createElement(LicenseField, { label: "DL", value: data.documentNumber }),
                            React.createElement(LicenseField, { label: "exp", value: data.expireDate })),
                        React.createElement(PropertyGroup, null,
                            React.createElement(LicenseField, { label: "LN", value: data.familyName }),
                            React.createElement(LicenseField, { label: "FN", value: data.givenName })),
                        React.createElement("p", { style: {
                                lineHeight: '1.3',
                                fontWeight: '600',
                                margin: '0',
                                fontSize: '1.5rem'
                            } },
                            data.address.split(',', 1)[0],
                            React.createElement("br", null),
                            " ",
                            data.address.split(',').slice(1).join(',').trim())),
                    React.createElement(Box, { style: {
                            display: 'grid',
                            gridTemplateRows: '1fr 1fr',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            gap: '0.5rem',
                            flexWrap: 'wrap'
                        } },
                        React.createElement(LicenseField, { label: "SEX", value: data.gender, variant: "compact" }),
                        React.createElement(LicenseField, { label: "EYES", value: data.eyeColor, variant: "compact" }),
                        React.createElement(LicenseField, { label: "DOB", value: data.birthDate, variant: "compact" }),
                        React.createElement(LicenseField, { label: "HGT", value: data.height, variant: "compact" }),
                        React.createElement(LicenseField, { label: "WGT", value: data.weight, variant: "compact" }),
                        React.createElement(LicenseField, { label: "ISS", value: data.issueDate, variant: "compact" }),
                        React.createElement(LicenseField, { label: "IACA", value: data.issuingAuthority, variant: "compact" })))))));
};
